import * as types from '@/store/types';
import { removeNamespaces } from '@/helpers/utils';

const localTypes = removeNamespaces(types);

export default {
  [localTypes.ROLES_SET](state, payload) {
    state.roles = payload;
  },
  [localTypes.ROLES_LOADING_SET](state, payload) {
    state.isRolesLoading = payload;
  },
};
